"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var Notification = /** @class */ (function () {
    function Notification() {
    }
    Object.defineProperty(Notification, "Instance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: false,
        configurable: true
    });
    Notification.prototype.init = function (showNotification) {
        Notification.instance.showNotification = showNotification;
    };
    Notification.prototype.show = function (message, isInfo) {
        // Only show message if Notification handler is initialized
        // Vizclient and VizportalClient will have different notification handler
        if (this.showNotification) {
            this.showNotification(message, isInfo);
        }
    };
    Notification.prototype.showInfo = function (message) {
        this.show(message, true);
    };
    Notification.prototype.showError = function (message) {
        this.show(message, false);
    };
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map